var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRealt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 132.3 160.4",
    style: {
      enableBackground: "new 0 0 132.3 160.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#191F29;}\n\t.st1{fill:#ACBA21;}\n\t.st2{fill:#8B9223;}\n\t.st3{fill:#B5CD30;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M125.6,34.3c-6.5,4-13.4,7.4-20,11.1c-1,0.6-1.7,0.3-2.6-0.2c-11.3-6.6-22.6-13-33.9-19.6 c-1.9-1.1-3.3-1.4-5.4-0.1c-11.1,6.6-22.5,13-33.7,19.5c-1.3,0.8-2.4,0.8-3.9,0c-6.2-3.7-12.6-7.1-18.9-10.7 c0.1-1.6,1.5-1.9,2.5-2.4c14.2-8.3,28.5-16.4,42.7-24.6c3.7-2.1,7.4-4.1,11-6.3c1.9-1.2,3.6-1.2,5.6-0.1 c18.2,10.5,36.5,21.1,54.8,31.5C124.6,32.8,125.4,33.3,125.6,34.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M131.4,125.6c-6.9,4-13.7,8-21.2,12.4c0-6.1,0-11.7,0-17.2c0-13,0-26,0.1-39c0-8.6,0-17.2,0-25.9 c0-1,0.1-1.8,1.2-2.4c6.7-3.5,13.3-7.1,19.9-10.6c1.1,1.1,0.9,2.5,0.9,3.8c0,25,0,50,0,75C132.3,123.1,132.3,124.5,131.4,125.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1.3,43C8,46.1,14.2,50,20.8,53.4c1.3,0.7,1.3,1.7,1.3,2.9c0,23.3,0,46.7-0.1,70c0,3.7,0,7.4,0,11.6 c-7.3-4.3-14.3-8.4-21.2-12.5c-0.4-1.2-0.4-2.5-0.4-3.7c0-24.7,0-49.4,0-74.1C0.4,46.1,0.1,44.3,1.3,43z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M38.5,51.5c9-5.2,17.7-10.3,26.4-15.3c0.8-0.5,1.5-0.5,2.4,0c8.8,5.1,17.6,10.1,26.8,15.4 c-4.6,2.6-8.9,5-13.2,7.3c-4.4,2.4-8.8,4.7-13.1,7.1c-1.1,0.6-2,0.9-3.2,0.2c-8.2-4.6-16.5-9-24.7-13.6 C39.6,52.4,39.2,52,38.5,51.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M31.9,59.5c6.3,3.5,12.3,6.7,18.2,9.9c2.9,1.6,5.7,3.2,8.6,4.7c1.5,0.8,2.2,1.7,2.2,3.5 c-0.1,6.4,0,12.8,0,19.8c-4.7-2.6-9.1-5.1-13.5-7.6c-4.5-2.5-9-5.1-13.5-7.6c-0.9-0.5-2-0.9-1.9-2.2C31.9,73.3,31.9,66.7,31.9,59.5 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M100.4,59.6c0,6.8,0,13.2,0,19.6c0,0.9-0.4,1.4-1.1,1.8c-9.4,5.3-18.8,10.6-28.5,16.1c0-7,0-13.6,0-20.2 c0-0.8,0.2-1.4,1.1-1.8C81.2,70,90.6,64.9,100.4,59.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M70.7,160.3c0-6.6,0-13.1,0-19.6c0-0.9,0.4-1.4,1.1-1.8c9.3-5.3,18.6-10.5,28.6-16.1c0,2.6,0,4.8,0,6.9 c0,4,0,8.1,0,12.1c0,1.1-0.1,2-1.3,2.6c-9.2,5.2-18.3,10.5-27.4,15.7C71.5,160.3,71.2,160.2,70.7,160.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M31.9,123.9c4.4,1.7,7.9,4.3,11.8,6.3c5.2,2.8,10.3,5.9,15.5,8.8c1.1,0.6,1.8,1.2,1.7,2.6 c-0.1,6,0,12.1,0,18.6c-3.7-2.1-7.1-3.9-10.4-5.9c-5.6-3.2-11.3-6.5-16.9-9.7c-1-0.6-1.7-1-1.7-2.3 C31.9,136.2,31.9,130.2,31.9,123.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M70.7,127.7c0-6.1,0-12.1,0-18.2c0-1,0.6-1.3,1.2-1.7c9.3-5.3,18.6-10.5,28.4-16c0,6.5,0,12.6,0,18.7 c0,0.9-0.7,1.3-1.3,1.7c-9.1,5.1-18.2,10.3-27.3,15.4C71.5,127.7,71.2,127.7,70.7,127.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M31.9,92.6c5.7,3.2,11,6.1,16.3,9.1c3.5,2,7,4,10.5,5.9c1.5,0.8,2.3,1.7,2.2,3.5c-0.1,5.6-0.1,11.3-0.1,17.4 c-5.3-3-10.3-5.8-15.3-8.6c-4-2.3-8-4.6-12-6.8c-1-0.5-1.7-1.1-1.7-2.4C31.9,104.8,31.9,98.9,31.9,92.6z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRealt);
export default __webpack_public_path__ + "static/media/realt.ebd638d87f18f1846446628161172732.svg";
export { ForwardRef as ReactComponent };